export default {"src":"/_next/static/media/RecipeArrow.aa0a3960.svg","height":16,"width":16};